var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-richText"},[_c('div',{staticClass:"mod-shop-richText"},[_c('section',{staticClass:"ql-snow",style:({'padding': _vm.content.padding/2 + 'px'})},[(_vm.content.text != '')?_c('div',{staticClass:"ql-editor wang-box",domProps:{"innerHTML":_vm._s(_vm.content.text)}}):_c('div',[_c('p',{},[_vm._v("请输入内容......")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }